import { rangeWithFallbackBounds } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_YEAR_FOUNDED = 1000;
const DEFAULT_MAX_YEAR_FOUNDED = 9999;

export const yearFoundedDescriptor = defineFilter({
  definition: {
    id: FilterId.YEAR_FOUNDED,
    name: 'Year Founded',
    type: FilterType.RANGE,
    min: undefined,
    max: undefined,
    isActive: false,
    isVisible: true,
  },
  handler: rangeWithFallbackBounds(
    DEFAULT_MIN_YEAR_FOUNDED,
    DEFAULT_MAX_YEAR_FOUNDED
  ),
});
